import http from './http'

const empresafornecedorService = {
  getByProgramaUsuario: (usuario) => http.get(`/niveis/${usuario}`).then(result => result.data),
  getByAll: () => http.get(`/empresafornecedorall`).then(result => result.data),
  getByTudo: () => http.get(`/fornecedoreshabilitados`).then(result => result.data),
  save: item => http.post('/empresafornecedor', item).then(result => result.data)
}
export default empresafornecedorService
